import React, { useRef, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "../assets/css/ClientLogoMarquee.css";

const ClientLogoMarquee = ({ logos = [], language = "en" }) => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let requestId;
    let position = 0;
    const speed = 0.5; // adjust scroll speed
    const direction = language === "ar" ? 1 : -1; // RTL = 1, LTR = -1

    const animate = () => {
      position += speed * direction;

      // Loop back seamlessly
      if (direction === -1 && Math.abs(position) >= track.scrollWidth / 2) {
        position = 0;
      } else if (direction === 1 && position >= 0) {
        position = -track.scrollWidth / 2;
      }

      track.style.transform = `translateX(${position}px)`;
      requestId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      cancelAnimationFrame(requestId);
    };
  }, [language, logos]);

  if (!logos.length) return null;

  // Duplicate logos to create seamless loop
  const loopedLogos = [...logos, ...logos];

  return (
    <div className="logo-marquee">
      <div className="logo-track" ref={trackRef}>
        {loopedLogos.map((logo, idx) => (
          <div className="logo-item" key={idx}>
            <LazyLoadImage src={logo.img} alt={logo.name || `Logo ${idx}`} className="logo-img"/>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientLogoMarquee;
